import { useCallback, useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";

const ImageCarousel = ({
  images = [],
  fallback,
  smallDots = false,
  originalSize = false, // default width
}) => {
  const [index, setIndex] = useState(0);

  const current = images[index];

  const prev = useCallback(() => {
    setIndex((i) => (i === 0 ? images.length - 1 : i - 1));
  }, [images.length]);

  const next = useCallback(() => {
    setIndex((i) => (i === images.length - 1 ? 0 : i + 1));
  }, [images.length]);

  useEffect(() => {
    if (index >= images.length) setIndex(0);
  }, [images.length]);

  if (!images?.length) {
    return fallback || null;
  }

  const currentImage = images[index];
  const imageSrc = getCloudinaryImageUrl(currentImage.imageUrl, {
    width: 800,
  });
  const showDots = images.length > 1 && images.length <= 6;

  return (
    <div className="relative w-full h-full group">
      {/* IMAGE */}
      <img
        onClick={next}
        src={originalSize ? currentImage?.imageUrl : imageSrc}
        alt={current.title || "Service image"}
        className="w-full h-full object-cover"
        loading="lazy"
        decoding="async"
      />

      {/* ARROWS */}
      {images.length > 1 && (
        <>
          <button
            onClick={prev}
            className={`absolute left-2 top-1/2  -translate-y-1/2 bg-black/40 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition`}
          >
            <FiChevronLeft className={` ${smallDots ? "size-4" : "size-6"}`} />
          </button>

          <button
            onClick={next}
            className={`absolute right-2 top-1/2  -translate-y-1/2 bg-black/40 text-white p-1 rounded-full opacity-0 group-hover:opacity-100 transition`}
          >
            <FiChevronRight className={` ${smallDots ? "size-4" : "size-6"}`} />
          </button>
        </>
      )}

      {/* DOT INDICATOR */}
      {showDots ? (
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1 shadow-lg">
          {images.map((_, i) => (
            <div
              key={i}
              className={`${smallDots ? "h-1" : "h-2"} rounded-full transition-all ${
                i === index ? "w-4 bg-white" : "w-2 bg-white/50"
              }`}
            />
          ))}
        </div>
      ) : (
        <>
          {index + 1 !== images.length && (
            <div className="absolute bottom-2 right-2 bg-black/40 backdrop-blur px-2 py-0.5 rounded text-white text-[10px]">
              {index + 1} / {images.length}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ImageCarousel;
